const { h, render, Component } = require('preact');

class CommonStatus extends Component {
  constructor() {
    super();
  }
  getClass() {
      if (this.props.landingView) {
          return "date-info-landing"
      }
      else
          return 'date-info'
  }
  render({label,value}) {
    return (<div class={this.getClass()}>
              <span>{label} {value}</span>
            </div>)
  }
}
module.exports = CommonStatus
